import React, { Component } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { getNewChartData, getDatasourceAndDates } from '../../../api'
import { isFullscreen } from '../utils/Utils';
import { xlsxCustomExport } from '../utils/chartConfig';
import SelectDataset from '../SelectDataset';

require('highcharts/modules/exporting')(Highcharts);
require('highcharts/modules/export-data')(Highcharts);
require('highcharts/highcharts-more')(Highcharts);

const IMG_URL = process.env.IMG_FULL_URL;

const xAxisColor = "#808080";

class SpiderBarChart extends Component
{
    constructor(props) {
		super(props);

        this.state = {
            selectedDataset: undefined,
            chartCategories: {
                '20049': [this.props.literals.L22153,this.props.literals.L22155,this.props.literals.L22156,this.props.literals.L22154],
                '20069': [this.props.literals.L22176,this.props.literals.L22177,this.props.literals.L22178],
                '20080': [this.props.literals.L22161,this.props.literals.L22159,this.props.literals.L22164,this.props.literals.L22162],
                '20101-15': [this.props.literals.L22157,this.props.literals.L22159,this.props.literals.L22163],
                '20101': [this.props.literals.L22157,this.props.literals.L22159,this.props.literals.L22158,this.props.literals.L22163],
                '20106': [this.props.literals.L22171,this.props.literals.L22172,this.props.literals.L22173,this.props.literals.L22174,this.props.literals.L22175]
            },
            chartConfig: {
                title: {
                    text: "<h2 class='title--card'>"+this.props.literals[`L${this.props.chartType[0].title}`]+"</h2>",
                    align: 'left',
					widthAdjust: -50,
					y:20,
					style: {
						zIndex: 1,
						lineHeight:36
					}
                },
				credits: {
					enabled: true,
					text: "",
					href: '',
					style: {
						cursor: 'arrow'
					},
					position: {
						x: -130
					}
				},
                chart: {
                    height: window.innerWidth > 768 ? 450 : 770,
                    type: this.props.type,
                    backgroundColor: '#F0F0F0',
                    marginTop: undefined,
                    events: {
                        render: function() {
                            var chart = this;
                            if (!chart.customImage)
                            {
                                chart.customImage = chart.renderer.image(
                                   `${IMG_URL}osh-barometer/img/EU-OSHA-en.png`,
                                   chart.chartWidth - 130,
                                   chart.chartHeight - 37,
                                   130,
                                   37
                                ).add();
                                chart.customImage.attr({
                                    class:'osha-logo'
                                });
                            }
                            else
                            {
                                chart.customImage.attr({
                                   x: chart.chartWidth - 130,
                                   y: chart.chartHeight - 37
                                });
                            }
                    
                            if (chart.fullscreen.isOpen) {
                                chart.customImage.css({
                                    display: 'block'
                                });
                                chart.container.className = 'highcharts-container full-screen';
                            }
                            else
                            {
                                chart.customImage.css({
                                    display: ''
                                });	
                                chart.container.className = 'highcharts-container';
                            }
                        }					
                    },
                },
                colors: this.props.colors,
				exporting: {
					enabled: this.props.exportingEnabled,
					scale: 1.5,
					sourceWidth: 1500,
					sourceHeight: 600,
					buttons: {
						contextButton: {
							menuItems: ["viewFullscreen", "printChart", "separator", "downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG", "separator", "downloadCSV", "downloadXLS"]							
						}
					},
                    menuItemDefinitions: {
                        "downloadXLS": {
                            onclick: function() {
                                xlsxCustomExport('Category', this.series, this.title.textStr);
                            }
                        }
                    }
				},
				navigation: {
					buttonOptions: {
						theme: {
							fill: 'transparent',
							states: {
								hover: {
									fill: '#CCC'
								},
								select: {
									fill: 'transparent'
								}
							}
						},
						verticalAlign: 'top',
						y: 0
					}
				},
				legend:{
					symbolRadius: 0,
					itemMarginTop:4,
					itemMarginBottom:4,
					itemStyle: {
						fontFamily: 'OpenSans',
						fontWeight: 'normal',
						fontSize:'12px',
						textOverflow: "ellipsis",
					}
				},
				tooltip: {					
					useHTML: true,
					opacity: 1,
					backgroundColor: "rgba(255, 255, 255, 1)",
					zIndex: 100,
					borderWidth:1,
					borderColor:"#529FA2",
					style: {
						zIndex: 100
					},
					formatter: function () {
						return '<ul class="tooltip-item">'+
						'<li><strong>Country: </strong>'+ this.series.name +' </li>' +
						'<li><strong>Indicator: </strong>'+ this.x  +' </li>' +
						'<li><strong class="tooltip-value up">Value: </strong> '+ this.y +'%</li>' +
						'</ul>';
					}
				},
                xAxis: {
                    lineWidth: 0,
                    max: this.props.yAxisMax,             
                    labels: {
                        style: {
							fontFamily: 'OpenSans-bold',
							fontWeight: 'normal',
							fontSize: this.props.fullCountryReport ? '8px' : '12px',
                            color:xAxisColor,
                            textOverflow: 'none',
                            padding:this.props.fullCountryReport ? 60 : 80,
						}
                    }
                },
                yAxis: {
                    gridLineColor:'#FFF',
                    gridLineWidth:2,
                    title: {
                        text: ''
                    },
                    gridLineColor: '#FFF',
                    gridLineWidth: 2,
                    labels: {
						format: this.props.percentage === true ? '{value:,.0f} %' : `{value:,.0f} ${this.props.percentage}`,
						style: {
							fontFamily: 'OpenSans-bold',
							fontWeight: 'normal',
							fontSize: this.props.fullCountryReport ? '10px' : '12px'
						}
                    },
                    min: 0,
                    max: 100
                },
                plotOptions: {
                    column: {
                        dataLabels: {
                            enabled: true,
                            overflow: 'none',
                            crop: false,
                            allowOverlap: true,
                            style: {
								textOutline: 0,
								textShadow: false,
								fontFamily: 'OpenSans-Bold',
								fontSize: this.props.fullCountryReport ? '10px' : '12px'
							},
							formatter: function () {                                
								return '<span style="color: ' + this.point.color + '">' + Math.round(this.y) + '%</span>';
							},
                        },
                        borderWidth: 0,  
                        pointStart: 0,
                        states: {
                            inactive: {
                                opacity: 1
                            }
                        },
                        groupPadding: this.props.fullCountryReport ? 0.2 : 0.15,
                        pointPadding: this.props.fullCountryReport ? 0.10 : 0.15,
                        point: {
                            events: {
                                mouseOver: function () {
                                    let series = this.series.data;
                                    series.forEach((p) => {
                                        p.setState('hover')
                                    });
                                },
                                mouseOut: function () {
                                    let series = this.series.data;
                                    series.forEach((p) => {
                                        p.setState();
                                    })
                                }
                            }
                        }
                    }
                },
                series: []
            },
            isLoading: true,
            typeCharts: [],
            selectedTypeChart: this.props.selectedIndicator != undefined ? this.props.selectedIndicator :  this.props.chartType[0].type,
            selectedChart: this.props.dataset === 'ewcs' ? this.props.chartType[1] : this.props.chartType[0]
        }
	}

    getLoadData = (chartType) => {
        let chart = [];
        
        if (chartType.length > 1) {
            chart = chartType.find((chart) => chart.type == this.props.datasetSource);
            if(this.props.callbackLegend != undefined){
                this.props.callbackLegend(chart.legend);
            }
        } else {
            chart = chartType[0];
            this.setState({ selectedTypeChart: null });
        }

        this.setState({ ...this.state, isLoading: true });
        try {
            let requestFilter = {
                chart: chart.chart,
                indicator: chart.chartIndicator,
                country1: this.props.selectCountry1,
                country2: this.props.selectCountry2,
                country3: this.props.selectCountry3,
                datasetIndicator1: this.props.datasetID
            }
            getNewChartData(requestFilter)
                .then((data) => {
                    let categories = this.state.chartCategories[chart.chart];
                    if (chart.chart == 20101 && this.props.datasetID == 15)
                    {
                        categories = this.state.chartCategories[chart.chart+"-"+this.props.datasetID]
                    }
                    this.setState({ chartConfig: {...this.state.chartConfig, xAxis: {...this.state.chartConfig.xAxis, categories }, series: data.resultset.data}})
                });
        } catch (error) {
            console.log('error', error)    
        } finally {
            setTimeout(() => {
                this.setState({ ...this.state, isLoading: false })
            }, 50);
        }
    }

    updateDimension = () => {
        const width = window.innerWidth;
        const height = window.innerHeight;
        const title =  "<h2 class='title--card'>"+this.props.literals[`L${this.props.chartType[0].title}`]+"</h2>"
        const tabTitle = "<h2 class='title--card'>"+this.props.literals[`L${this.props.tabIndicator}`]+"</h2>"

        if (width > 767) {
            if (isFullscreen()) {
                this.setState({
                    chartConfig: {
                        ...this.state.chartConfig,
                        chart: {...this.state.chartConfig.chart, height: height}
                    }
                });
            } else {
                this.setState({
                    chartConfig: {
                        ...this.state.chartConfig,
                        chart: {...this.state.chartConfig.chart, height: this.props.fullCountryReport == true ? 250 : 450, type: 'column'}
                    }
                });
            }
        }

        if (width < 768) {
            if (isFullscreen()) {
                this.setState({
                    chartConfig: {
                        ...this.state.chartConfig,
                        chart: {...this.state.chartConfig.chart, height: height}
                    }
                });
            } else {
                this.setState({
                    chartConfig: {
                        ...this.state.chartConfig,
                        chart: {...this.state.chartConfig.chart, height: 770}
                    }
                })
            }
        }
    }

    componentDidMount(){
		this.getLoadData(this.props.chartType);

        this.setState({ typeCharts: this.props.chartType.map((chart) => chart.type) });

        if (this.props.callbackSelectedSurvey)
		{
			if (this.props.chartType[0].type == 'ewcs' && this.props.chartType.length > 1) {
				this.props.callbackSelectedSurvey(this.props.chartType[1].type)
			} else {
				this.props.callbackSelectedSurvey(this.props.chartType[0].type)
			}
		}		
        this.updateDimension();
        window.addEventListener('resize', this.updateDimension);
	}

	componentDidUpdate(prevProps,prevState){
		if (prevProps.chartType != this.props.chartType)
		{
			this.setState({ typeCharts: this.props.chartType.map((chart) => chart.type), selectedDataset: undefined, });

			this.getLoadData(this.props.chartType);
            this.updateDimension();
		}		

		if(prevProps.selectCountry1 != this.props.selectCountry1 || prevProps.selectCountry2 != this.props.selectCountry2 ||
			prevProps.selectCountry3 != this.props.selectCountry3 || prevProps.datasetID != this.props.datasetID){
            this.getLoadData(this.props.chartType);
        }

        if (prevProps.type != this.props.type) {
            this.setState({ chartConfig: {...this.state.chartConfig, chart: {...this.state.chartConfig.chart, type: this.props.type} }})
        }

		if(prevState.selectedDataset != this.state.selectedDataset) {
			this.getLoadData(this.props.chartType);
		}

		if(this.state.selectedChart == undefined){
			const chart = this.props.chartType.find((chart) => chart.type == this.props.dataset);
        	this.setState({ selectedTypeChart: chart.type, selectedChart: chart });
		}
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.updateDimension);
	}

    render()
    {
        return(
            <div className='chart-container'>
                <HighchartsReact
                    highcharts={Highcharts}
                    options={this.state.chartConfig}
                    containerProps={{ className: 'chartContainer' }}
                />
            </div>
        )
    }
}

export default SpiderBarChart;